<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div v-if="activeMode == 'personalRights'" class="page-wrapper">
                <div class="page-back-wrapper">
                    <div class="page-back" @click="handleBack">
                        <img src="@/assets/img/back.png" alt="" class="page-back-img">
                        <span>返回</span>
                    </div>
                </div>
                <div class="page-content-container">
                    <div class="page-content-header">
                        <div class="page-header-block"></div>
                        <div v-for="(item, key) in navList" :key="key" @click="handleNav(item.id)"
                            :class="activeNav == item.id ? 'page-content-header-item-active' : 'page-content-header-item'">
                            {{ item.label }}
                        </div>
                    </div>
                    <div class="page-content-wrapper">
                        <div class="page-content">
                            <div v-if="activeNav == 'live-learn'">
                                <LiveLearn></LiveLearn>
                            </div>
                            <div v-if="activeNav == 'record-learn'">
                                <RecordCourse></RecordCourse>
                            </div>
                            <div v-if="activeNav == 'offline-courses'">
                                <OfflineCourses></OfflineCourses>
                            </div>
                            <div v-if="activeNav == 'experts-answer'">
                                <ExpertsAnswer @mode="getMode"></ExpertsAnswer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="activeMode == 'questionDetail'" class="page-wrapper">
                <div class="page-back-wrapper">
                    <div class="page-back" @click="backQuestainAnswer">
                        <img src="@/assets/img/back.png" alt="" class="page-back-img">
                        <span>返回</span>
                    </div>
                </div>
                <div class="page-content-container">
                    <div class="page-content-wrapper">
                        <div class="page-content">
                            <QuestionDetail :questionId="questionRow"></QuestionDetail>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import LiveLearn from './components/LiveLearn.vue'
import RecordCourse from './components/RecordCourse.vue'
import OfflineCourses from './components/OfflineCourses.vue'
import ExpertsAnswer from './components/ExpertsAnswer.vue'
import QuestionDetail from './components/QuestionDetail.vue'
export default {
    name: '',
    components: {
        Header,
        LiveLearn,
        RecordCourse,
        OfflineCourses,
        ExpertsAnswer,
        QuestionDetail
    },
    data() {
        return {
            dept: '',
            token: '',
            navList: [
                {
                    id: 'live-learn',
                    label: '直播学习'
                },
                {
                    id: 'record-learn',
                    label: '录播学习'
                },
                // {
                //     id:'offline-courses',
                //     label:'线下公开课'
                // },
                // {
                //     id:'test-practice',
                //     label:'试题练习'
                // },
                // {
                //     id:'test-simulation',
                //     label:'考试模拟'
                // },
                // {
                //     id:'experts-answer',
                //     label:'专家答疑'
                // }
            ],
            activeNav: 'live-learn',
            activeMode: 'personalRights',
            questionRow: null
        }
    },
    mounted() {
        scrollTo(0, 0);
        this.activeNav = this.$route.params.mode;
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
            //   this.$router.push(`/index/enterprise-center/${this.dept}/${this.token}`);
        },
        handleNav(target) {
            this.activeNav = target;
        },
        getMode(params) {
            var data = JSON.parse(params);
            this.activeMode = data.mode;
            this.questionRow = data.id;
        },
        backQuestainAnswer() {
            this.activeMode = 'personalRights';
            this.activeNav = 'experts-answer';
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    margin: 0 auto;
}

.page-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 100px;
}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    display: flex;
    align-items: center;
    margin-top: 18px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top: 18px;
}

.page-content-header {
    width: 100%;
    height: 80px;
    background: #F8FAFF;
    border-radius: 6px 5px 0px 0px;
    line-height: 80px;
    position: relative;
    display: flex;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-content-header-item:hover {
    color: #4F79ED;
    cursor: pointer;
}

.page-content-header-item-active {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
}

.page-content-wrapper {
    display: flex;
}

.page-content {
    flex: 1;
    margin: 30px 41px 30px 45px;
}</style>


